export default function AuditTimeline({ items = [], onItemClick }) {
  if (items.length === 0) {
    return (
      <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', padding: '0.5rem 0' }}>
        Sin registros de auditoría.
      </div>
    );
  }

  return (
    <div className="aui-timeline">
      {items.map((item, idx) => {
        const clickable = Boolean(item.onClick || (onItemClick && item.clickable));
        const handleClick = () => {
          if (item.onClick) item.onClick(item);
          else onItemClick?.(item);
        };
        const content = (
          <>
            <span className="dot" />
            <div className="content">
              <div className="title">{item.title}</div>
              {item.time && <div className="time">{item.time}</div>}
              {item.description && (
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
                  {item.description}
                </div>
              )}
            </div>
          </>
        );

        return clickable ? (
          <button key={idx} type="button" className="item is-clickable" onClick={handleClick}>
            {content}
          </button>
        ) : (
          <div key={idx} className="item">
            {content}
          </div>
        );
      })}
    </div>
  );
}
